import { ApiClient, apiClient } from '~app/core/api-client';
import { deserialize, serialize } from '~app/shared/json-mapper';
import { AccountModel } from '~app/modules/account/types';

export class AccountService {
  private _path = '/account';
  constructor(private apiClient: ApiClient) {}
  getById(id: string): Promise<any> {
    return apiClient
      .get(`${this._path}/${id}?populate=tenants`)
      .then((res) => deserialize(AccountModel, res.data));
  }
  update(payload: AccountModel): Promise<any> {
    const { id } = payload;
    return (
      apiClient
        .put(`${this._path}/${id}`, serialize(payload))
        //TODO remove redundant request once user model  separate tenantIds from tenants properties
        .then((res) => this.getById(res.data._id))
    );
  }
  updateEmail({ id, email }: { id: string; email: string }): Promise<any> {
    return this.apiClient.put<void>(`${this._path}/${id}/email`, { email }).then((res) => res.data);
  }
  updatePassword({
    id,
    password,
    newPassword,
  }: {
    id: string;
    password: string;
    newPassword: string;
  }): Promise<any> {
    return this.apiClient
      .put<void>(`${this._path}/${id}/password`, { password, newPassword })
      .then((res) => res.data);
  }
}

export const accountService = new AccountService(apiClient);
